import * as React from "react"

import { cn } from "@/lib/utils"
import { PhoneInput } from "@/components/ui/phone-input"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  if (type === "tel") return <PhoneInput ref={ref} className={cn("app-input h-10 min-h-10 w-full rounded-md border border-input bg-transparent text-base shadow-sm md:text-sm", className)} {...props} />;
  return (
    <input
      type={type}
      className={cn(
        "app-input flex h-10 min-h-10 w-full min-w-0 rounded-md border border-input bg-transparent px-3 py-2 text-base leading-snug shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
